<template>
  <div class="toast-container">
    <TransitionGroup name="toast" tag="div">
      <div
        v-for="toast in toasts"
        :key="toast.id"
        :class="['toast', `toast-${toast.type}`]"
        @click="removeToast(toast.id)"
      >
        <i :class="getIcon(toast.type)"></i>
        <span>{{ toast.message }}</span>
        <button class="toast-close" @click.stop="removeToast(toast.id)">
          <i class="bi bi-x"></i>
        </button>
      </div>
    </TransitionGroup>
  </div>
</template>

<script setup>
import { useToast } from '@/composables/useToast'

const { toasts, removeToast } = useToast()

const getIcon = (type) => {
  const icons = {
    success: 'bi bi-check-circle-fill',
    error: 'bi bi-x-circle-fill',
    warning: 'bi bi-exclamation-triangle-fill',
    info: 'bi bi-info-circle-fill'
  }
  return icons[type] || icons.info
}
</script>

<style scoped>
.toast-container {
  position: fixed;
  top: 80px;
  right: 16px;
  z-index: 10000;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 320px;
}

.toast {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: var(--card, #ffffff);
  border-radius: 8px;
  box-shadow: var(--shadow-lg, 0 4px 16px rgba(0, 0, 0, 0.15));
  cursor: pointer;
  animation: slideIn 0.3s ease;
}

.toast-success {
  border-left: 4px solid var(--success, #4caf50);
}

.toast-error {
  border-left: 4px solid var(--danger, #f44336);
}

.toast-warning {
  border-left: 4px solid var(--warning, #ff9800);
}

.toast-info {
  border-left: 4px solid var(--primary, #ff6530);
}

.toast i {
  font-size: 20px;
}

.toast-success i {
  color: var(--success, #4caf50);
}

.toast-error i {
  color: var(--danger, #f44336);
}

.toast-warning i {
  color: var(--warning, #ff9800);
}

.toast-info i {
  color: var(--primary, #ff6530);
}

.toast span {
  flex: 1;
  font-size: 14px;
  color: var(--text, #1a1a1a);
}

.toast-close {
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;
  color: var(--text-muted, #666666);
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s ease;
}

.toast-enter-from {
  opacity: 0;
  transform: translateX(100%);
}

.toast-leave-to {
  opacity: 0;
  transform: translateX(100%);
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(100%);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
</style>

